"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BundleAPI_1 = tslib_1.__importDefault(require("../../common/api/assisted-service/BundleAPI"));
const BundleService = {
    listBundles() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { data: bundles } = yield BundleAPI_1.default.list();
            return bundles;
        });
    },
    listOperatorsByBundle(bundleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { data } = yield BundleAPI_1.default.listOperatorsForBundle(bundleName);
            return data;
        });
    },
};
exports.default = BundleService;
//# sourceMappingURL=BundleService.js.map